// PRODUCTION — live-updates banner summarizing validation issues that block saving.
import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { GSIcon } from 'src/components/shared/GSIcon'
import type { DocumentValidationResult } from 'src/utils/flowEditorDocument/types'

const ValidationBannerComponent = ({ validation }: { validation: DocumentValidationResult }) => {
  const issueCount = validation.invalidStepLocalIds.length + validation.emptyGroupLocalIds.length

  return (
    <div css={tw`flex items-start gap-2 rounded-[10px] bg-warning-200 p-2.5`}>
      <GSIcon
        iconName="gs_triangle_exclamation"
        width={20}
        height={16}
        css={tw`mt-0.5 flex-shrink-0 fill-warning-600`}
      />
      <div css={tw`flex flex-col gap-0.5`}>
        <Typography variant="subtitle1" css={tw`text-warning-700`}>
          {issueCount === 1 ? '1 issue blocks saving' : `${issueCount} issues block saving`}
        </Typography>
        {validation.blockingMessage !== null && (
          <Typography variant="body2" css={tw`text-warning-700`}>
            {validation.blockingMessage}
          </Typography>
        )}
      </div>
    </div>
  )
}

export const ValidationBanner = memo(ValidationBannerComponent)
